import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=f5d3e3b8&scoped=true&lang=html"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=f5d3e3b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d3e3b8",
  null
  
)

export default component.exports